import request from '../request'

// 查询离职申请列表 (GET)
export function fetchList(params) {
    return request({
        url: '/office-service/oa/leave/list',
        method: 'get',
        params
    })
}

// 查询离职申请详情 (GET)
export function fetchDetail(id) {
    return request({
        url: `/office-service/oa/leave/detail/${id}`,
        method: 'get'
    })
}

// 新增离职申请 (POST)
export function add(data) {
    return request({
        url: '/office-service/oa/leave/add',
        method: 'post',
        data
    })
}
// 重新提交离职申请 (POST)
export function resubmit(data) {
    return request({
        url: '/office-service/oa/leave/resubmit',
        method: 'post',
        data
    })
}

export function hasApprovableAssets(userId) {
    return request({
        url:    `/office-service/fixed-asset/has-approvable-assets/${userId}`,
        method: 'post'
    })
}
